import { MouseEvent } from 'react'
import { UnstyledButton } from '@mantine/core'
import { useTheme } from 'styled-components'
import { Theme } from '../../theme'
import { PaginationItemProps } from './pagination.types'
import { getItemVars } from './item-vars'
import styles from './pagination.module.scss'

export const PaginationItem = ({
  children,
  onClick,
  isActive,
  disabled,
  ...ariaProps
}: PaginationItemProps) => {
  const theme = useTheme() as Theme

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    // Keep a clickable parent from also reacting to the item (react-aria did this).
    event.stopPropagation()
    onClick()
  }

  return (
    <UnstyledButton
      {...ariaProps}
      type="button"
      className={styles.item}
      style={getItemVars(theme)}
      disabled={disabled}
      aria-current={isActive ? 'page' : undefined}
      onClick={handleClick}
    >
      {children}
    </UnstyledButton>
  )
}
